@let recordItems = recordItemsSg();
@let recordsLoading = recordsLoadingSg();
@let recordsError = recordsErrorSg();

<atn-ds-select-single
  [label]="entityNameSg()"
  [config]="{
    overlay: {
      minSearchCharacters: 1,
      entityName: 'Record',
      hasSearch: true,
    },
  }"
  [items]="recordItems"
  [loading]="recordsLoading"
  [error]="recordsError?.toString()"
  [(value)]="valueSg"
/>
